(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Utility Functions
  const safeDOM = {
    query: (selector) => {
      try {
        return document.querySelector(selector);
      } catch (e) {
        console.warn(`Query failed for ${selector}:`, e);
        return null;
      }
    },
    queryAll: (selector) => {
      try {
        return document.querySelectorAll(selector);
      } catch (e) {
        console.warn(`QueryAll failed for ${selector}:`, e);
        return [];
      }
    },
    addClass: (element, className) => {
      if (element?.classList) {
        element.classList.add(className);
      }
    },
    removeClass: (element, className) => {
      if (element?.classList) {
        element.classList.remove(className);
      }
    },
    toggleClass: (element, className) => {
      if (element?.classList) {
        element.classList.toggle(className);
      }
    }
  };

  // Prevenir errores comunes
  if (typeof SearchForm === 'undefined') {
    window.SearchForm = { prototype: {} };
  }

  // Manejo global de errores
  const errorHandler = {
    ignoredErrors: [
      'SearchForm is not defined',
      'appendChild',
      'classList',
      'Receiving end does not exist',
      'Cannot read properties of undefined',
      'Failed to fetch',
      'Unable to export metrics',
      'Add to Cart Button Not found'
    ],

    init() {
      window.onerror = (msg, url, lineNo, columnNo, error) => {
        if (this.ignoredErrors.some(e => msg.includes(e))) {
          return true;
        }
        return false;
      };

      window.addEventListener('unhandledrejection', (event) => {
        if (this.ignoredErrors.some(e => event.reason?.message?.includes(e))) {
          event.preventDefault();
        }
      });
    }
  };

  // Cart Management
  class CartManager {
    constructor() {
      this.init();
    }

    init() {
      this.setupCartDrawer();
      this.setupCartButtons();
    }

    setupCartDrawer() {
      customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
        constructor() {
          super();
          this.bindEvents();
        }

        bindEvents() {
          this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
          const overlay = this.querySelector('.cart-drawer__overlay');
          if (overlay) {
            overlay.addEventListener('click', () => this.close());
          }
        }

        open() {
          this.setAttribute('open', '');
          document.body.classList.add('overflow-hidden');
        }

        close() {
          this.removeAttribute('open');
          document.body.classList.remove('overflow-hidden');
        }
      });
    }

    setupCartButtons() {
      const cartButtons = safeDOM.queryAll('.header__cart-button');
      cartButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const cartDrawer = safeDOM.query('cart-drawer');
          if (cartDrawer) cartDrawer.open();
        });
      });
    }
  }

  // Mobile Menu Management
  class MobileMenuManager {
    constructor() {
      this.menuDrawer = safeDOM.query('.menu-drawer');
      this.overlay = safeDOM.query('.menu-drawer__overlay');
      this.toggleButton = safeDOM.query('.header__mobile-toggle');
      this.closeButton = safeDOM.query('.menu-drawer__close');
      this.menuLinks = safeDOM.queryAll('.menu-drawer__link');
      this.submenuToggles = safeDOM.queryAll('.menu-drawer__toggle');
      this.isOpen = false;

      this.init();
    }

    init() {
      this.bindEvents();
      this.setupKeyboardEvents();
      this.setupSubmenuToggles();
    }

    bindEvents() {
      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', () => this.toggle());
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      this.menuLinks.forEach(link => {
        link.addEventListener('click', () => this.close());
      });
    }

    setupSubmenuToggles() {
      this.submenuToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          const submenu = toggle.nextElementSibling;
          safeDOM.toggleClass(submenu, 'active');
        });
      });
    }

    setupKeyboardEvents() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      if (!this.menuDrawer || !this.overlay) return;
      
      this.isOpen = true;
      safeDOM.addClass(this.menuDrawer, 'active');
      safeDOM.addClass(this.overlay, 'active');
      document.body.style.overflow = 'hidden';
    }

    close() {
      if (!this.menuDrawer || !this.overlay) return;
      
      this.isOpen = false;
      safeDOM.removeClass(this.menuDrawer, 'active');
      safeDOM.removeClass(this.overlay, 'active');
      document.body.style.overflow = '';
      this.submenuToggles.forEach(toggle => {
        const submenu = toggle.nextElementSibling;
        safeDOM.removeClass(submenu, 'active');
      });
    }
  }

  // Header Management
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = this.querySelector('.header');
      this.headerBounds = {};
      this.lastScrollTop = 0;
      this.ticking = false;

      if (this.getAttribute('data-sticky-type') === 'always') {
        safeDOM.addClass(this, 'sticky-header');
      }
    }

    connectedCallback() {
      if (!this.header) return;
      
      this.setHeaderHeight();
      this.setupObserver();
      this.setupScrollHandler();
    }

    setHeaderHeight() {
      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    setupObserver() {
      const mediaQuery = window.matchMedia('(max-width: 989px)');
      mediaQuery.addListener(() => this.setHeaderHeight());
    }

    setupScrollHandler() {
      if (this.getAttribute('data-sticky-type') === 'on-scroll-up') {
        window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
      }
    }

    handleScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.updateHeaderVisibility();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    updateHeaderVisibility() {
      const currentScroll = window.pageYOffset;
      if (currentScroll < this.lastScrollTop) {
        safeDOM.removeClass(this, 'header--hidden');
      } else if (currentScroll > 50) {
        safeDOM.addClass(this, 'header--hidden');
      }
      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }
  }

  // Resource Handler
  class ResourceHandler {
    constructor() {
      this.blockedResources = new Set();
      this.init();
    }

    init() {
      this.handleBlockedResources();
      this.setupResourceErrorHandler();
    }

    handleBlockedResources() {
      ['consent-tracking-api.js', 'monorail-edge.shopifysvc.com', 'static-tracking.klaviyo.com'].forEach(
        resource => this.blockedResources.add(resource)
      );
    }

    setupResourceErrorHandler() {
      window.addEventListener('error', (e) => {
        if (e.target instanceof HTMLScriptElement || e.target instanceof HTMLLinkElement) {
          const resource = e.target.src || e.target.href;
          if (resource && this.shouldBlock(resource)) {
            e.preventDefault();
            return true;
          }
        }
      }, true);
    }

    shouldBlock(resource) {
      return Array.from(this.blockedResources).some(blocked => resource.includes(blocked));
    }
  }

  // Initialization
  document.addEventListener('DOMContentLoaded', () => {
    try {
      errorHandler.init();
      customElements.define('sticky-header', StickyHeader);
      new CartManager();
      new MobileMenuManager();
      new ResourceHandler();
    } catch (error) {
      console.warn('Error during initialization:', error);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
